module.exports = __webpack_public_path__ + "img/9.87bd55d9.jpg";